import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconWorkWithAPro = deprecatedComponent({
    displayName: 'IconWorkWithAPro',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 28 28",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("rect", {
            x: 18,
            y: 18,
            width: 3,
            height: 3,
            stroke: "black",
            strokeWidth: 1.5
        }), /*#__PURE__*/ React.createElement("rect", {
            x: 3,
            y: 18,
            width: 3,
            height: 3,
            stroke: "black",
            strokeWidth: 1.5
        }), /*#__PURE__*/ React.createElement("rect", {
            x: 18,
            y: 3,
            width: 3,
            height: 3,
            stroke: "black",
            strokeWidth: 1.5
        }), /*#__PURE__*/ React.createElement("rect", {
            x: 3,
            y: 3,
            width: 3,
            height: 3,
            stroke: "black",
            strokeWidth: 1.5
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M6.01367 6.0138V4.5138L18.0137 4.51379V6.01379L19.5137 6.0138V18.0138H18.0137V19.5138H6.01367V18.0138H4.51367V6.0138H6.01367Z",
            stroke: "black",
            strokeWidth: 1.5
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M8.44922 13.2732L10.2657 10.8512L12.0821 13.2732H8.44922Z",
            fill: "black"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M10.8711 13.2734L13.5957 9.64038L16.3204 13.2734H10.8711Z",
            fill: "black"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M24.6665 23.0873L22.7931 22.4629C22.4023 22.3326 22.0304 22.7044 22.1607 23.0953L22.7851 24.9687C22.9202 25.3739 23.4684 25.4341 23.6882 25.0678L24.0279 24.5016C24.0702 24.4312 24.1291 24.3723 24.1994 24.3301L24.7656 23.9904C25.1319 23.7706 25.0717 23.2224 24.6665 23.0873Z",
            fill: "black"
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconWorkWithAPro };
